export default "__VITE_ASSET__DI_AzYxZ__"